export const initialTab = {
  name: "",
  type: "",
  configurations: null,
  configured: false,
  id:""
};